import React from 'react'

export const requiredFieldSign = (<span className="text-danger">*</span>)